export enum PaymentMethod {
  CREDIT_CARD = "CREDIT_CARD",
  CASH = "CASH",
  BANK_TRANSFER = "BANK_TRANSFER",
  BANK_TRANSFER_MP = "BANK_TRANSFER_MP",
  AUTOMATIC_DEBIT = "AUTOMATIC_DEBIT",
  PAYMENT_CHECK = "PAYMENT_CHECK",
}
